import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { message, Popconfirm, Switch } from 'antd';
import { toUpper } from 'lodash';
import { useTranslation } from 'react-i18next';

import { permissions } from '@/constants';
import { useStores } from '@/hooks/use-stores';

const CUSTOM_ALERT_TYPE = 'CUSTOM';
const MANUFACTURER_ALERT_TYPE = 'MANUFACTURER';

const ActivateAlertRuleColumn = observer(({ alertRule }) => {
  const { permissionStore, rulesStore } = useStores();
  const { t } = useTranslation();
  const [isChangingState, setIsChangingState] = useState(false);

  const onClickOKActivationSwitch = async alertRule => {
    const newState = toUpper(alertRule.state) === 'ACTIVATED' ? 'deactivated' : 'activated';
    await rulesStore.update({ state: newState }, alertRule.alertType, alertRule.id);
  };

  const onConfirm = async () => {
    setIsChangingState(true);
    try {
      await onClickOKActivationSwitch(alertRule);
    } catch (e) {
      message.error(t('Failed to change activation status'));
    } finally {
      setIsChangingState(false);
    }
  };

  const disabled = (() => {
    switch (toUpper(alertRule.alertType)) {
      case CUSTOM_ALERT_TYPE:
        return !permissionStore.isAuth(permissions.UPDATE_CUSTOM_ALERT);

      case MANUFACTURER_ALERT_TYPE:
        return !permissionStore.isAuth(permissions.UPDATE_MANUFACTURER_ALERT);

      default:
        return true;
    }
  })();

  return (
    <Popconfirm
      placement="bottom"
      title={
        toUpper(alertRule.state) === 'ACTIVATED'
          ? t('Are you sure you want to stop monitoring and alerting on this type of events?')
          : t('Are you sure you want to start monitoring and alerting on this type of events?')
      }
      onConfirm={onConfirm}
      okText={t('Yes')}
      cancelText={t('Cancel')}
      icon={null}
      disabled={disabled}
    >
      <Switch
        size="small"
        checked={toUpper(alertRule.state) === 'ACTIVATED'}
        loading={isChangingState}
        disabled={disabled}
      />
    </Popconfirm>
  );
});

export default ActivateAlertRuleColumn;
